import classes from "./Header.module.css";
import SearchIcon from "../../images/header/searchIcon.svg";
import NotificationIcon from "../../images/header/notificationIcon.svg";
import { useLocation } from "react-router-dom";
import { setSearchQuery } from "../../redux/misc/slices/searchSlice";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { LanguageSwitcher } from "../languageSwitcher/LanguageSwitcher";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export function Header() {
  const searchQuery = useSelector((state) => state.search.query);
  const [query, setQuery] = useState("");
  const { t } = useTranslations();
  const dispatch = useDispatch();
  const location = useLocation();

  // Update local query state when Redux state changes
  useEffect(() => {
    setQuery(searchQuery);
  }, [searchQuery]);

  const handleSearch = () => {
    dispatch(setSearchQuery(query));
  };

  useEffect(() => {
    if (query === "") {
      dispatch(setSearchQuery(""));
    }
  }, [query]);

  const shouldShowSearch =
    location.pathname === "/deliveries" ||
    location.pathname === "/dashboard" ||
    location.pathname === "/drivers" ||
    location.pathname === "/addresses";

  return (
    <section className={classes.header}>
      <div className={`${classes.contentHeader} fadeInTranslate`}>
        {shouldShowSearch && (
          <label className={classes.search} htmlFor="search">
            <input
              type="text"
              id="search"
              placeholder={t.header.searchPlaceholder}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
            <label htmlFor="search">
              <img src={SearchIcon} alt="search icon" onClick={handleSearch} />
            </label>
          </label>
        )}

        <div
          className={classes.headerIcons}
          style={{
            width: !shouldShowSearch ? "100%" : "",
            justifyContent: !shouldShowSearch ? "flex-end" : "",
          }}
        >
          <button className={classes.notificationBtn}>
            <img src={NotificationIcon} alt="notification icon" />
          </button>
          <LanguageSwitcher />
        </div>
      </div>
    </section>
  );
}
